
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flips",
      function () {
        return require("private-next-pages/flips/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flips"])
      });
    }
  